// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"efb45e85","146":"2d1dfeac","153":"6c911f5d","157":"52e18d94","187":"be123824","203":"efb49618","285":"19ffb1d2","365":"ff18845b","386":"3196965a","453":"ea025e36","556":"43597497","746":"1de4bdde"}[chunkId] + ".chunk.js";
};